<script setup>
import { useI18n } from 'vue-i18n';
import { useCustomerStore } from '@client/js/store/customer';
const customerStore = useCustomerStore();
const { t } = useI18n();

import iconEmail from '@client/svg/email.svg?raw';
import iconPhone from '@client/svg/phone.svg?raw';
import iconUser from '@client/svg/user.svg?raw';
import iconLoc from '@client/svg/loc.svg?raw';

</script>
<template>
    <div class="userInfo">
        <div class="userInfoRow">
            <div class="iconw" v-html="iconUser" v-show="customerStore.firstName && customerStore.lastName"></div>
            {{ customerStore.firstName }} {{ customerStore.lastName }}
        </div>
        <div class="userInfoRow">
            <div class="iconw" v-html="iconPhone" v-show="customerStore.phoneNumber"></div>
            {{ customerStore.phoneNumber }}
        </div>
        <div class="userInfoRow">
            <div class="iconw" v-html="iconEmail" v-show="customerStore.email"></div>
            {{ customerStore.email }}
        </div>
        <div class="userInfoRow" v-if="customerStore.isDeliveryOrder">
            <div class="iconw" v-html="iconLoc"></div>
            {{ [customerStore?.street, customerStore?.city, customerStore?.state,customerStore?.zip].filter(Boolean).join(', ').replace(/^[\s,]+|[\s,]+$/g, '') }}
        </div>
        <div class="userInfoRow userInfoRowReset">
            <div class="userInfoNote">{{ t('customerCard.notYou') }}</div>
            <button type="button" class="userInfoReset" @click="customerStore.resetCustomerID()">{{ t('customerCard.reset') }}</button>
        </div>
    </div>
</template>
<style scoped lang="scss">
.userInfo {
    display: grid;
    gap: 0.25rem;

    &Row {
        font-weight: 400;
        color: var(--text-secondary);
        font-size: 0.875rem;
        display: inline-flex;
        align-items: center;

        .iconw {
            font-size: 0.75rem;
            margin-right: 0.375rem;
        }

        &Reset {
            margin: 0.5rem -1rem -1rem;
            text-align: right;
            justify-content: flex-end;
            opacity: 0.75;
        }
    }

    &Note {
        margin-right: 0.375rem;
    }
    &Reset {
        cursor: pointer;
        font-weight: 400;
        font-size: .6875rem;
        background-color: var(--c-primary);
        padding: 0.5rem 0.75rem;
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        line-height: 0.77;
        border-radius: 4px 0 0 0;
        transform: translate3d(1px,1px, 0);
        letter-spacing: -0.25px;
    }
}
</style>